module.exports = __webpack_public_path__ + "static/media/1.aad4342f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16466/1.jpg
// module id = 564
// module chunks = 0